window.baseURL = 'https://helpdeskbackend.ebusinessafrique.com/api/v1';
// window.baseURL = 'http://localhost:8001/api/v1';
// window.baseURL = 'http://104.248.251.33:8484/api/v1';
// window.baseURL = 'http://127.0.0.1:8084/api/v1';
// window.baseURL = 'http://helpdesk.test/api/v1';

import axios from 'axios'

axios.defaults.baseURL = window.baseURL;

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['credentials'] = 'same-origin';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access');
axios.defaults.headers.post['Content-Type'] = 'application/form-data';
export default axios.create({});
